import $ from 'jquery';
import { getProductGroupFactory } from './get-set-grid-factory';

export function createProductGroupsGridFromNewPackage({
  campaign,
  adgroup,
  level,
  gridParameters,
  callbacks,
  filterService,
  isTreeView,
}) {
  const productGroupGrid = getProductGroupFactory()({
    campaign,
    adgroup,
    level,
    gridParameters,
    callbacks,
    filterService,
    preferenceConfig: null,
    viewport: null,
    getAdditionalPlugins: () => [],
    customHeaderOffset: () => $('.toolbar').height(),
    isTreeView,
    p$daterange: null,
  });

  return productGroupGrid;
}
